var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3 10.2c1 0 1.7-.8 1.7-1.7V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v44a3 3 0 0 0 3 3h44a3 3 0 0 0 3-3V19.3a1.7 1.7 0 0 0-3.5 0v27.3h-43v-43h43v5c0 1 .8 1.7 1.8 1.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 22.5h-3.7l7.2 10h3.7l12.8-17.3h-3.7L21.5 30l-5.3-7.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpSummary);
export default __webpack_public_path__ + "static/media/gp-summary.e06bbb09.svg";
export { ForwardRef as ReactComponent };